import * as React from "react";
const SvgPrettify = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 25, height: 25, fill: "none", viewBox: "0 0 25 25", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeWidth: 1.563, d: "m10.285 24.075 3.429-6m.86 6 2.572-4.286m2.341 4.285 1.236-2.322a5.98 5.98 0 0 0-1.089-7.065l4.164-7.808a1.714 1.714 0 0 0-3.025-1.614l-4.165 7.81a5.98 5.98 0 0 0-6.473 3.025L6 24.073" }), /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeLinejoin: "round", strokeWidth: 1.563, d: "m4 15 1-2 2-1-2-1-1-2-1 2-2 1 2 1zm7.5-7 1.166-2.334L15 4.5l-2.334-1.166L11.5 1l-1.166 2.334L8 4.5l2.334 1.166z" }));
export {
  SvgPrettify as default
};
//# sourceMappingURL=prettify.js.map
